import styled from 'styled-components'

export const Container = styled.div`
  h4 {
    font-family: Ubuntu, sans-serif;
    -webkit-font-smoothing: antialiased;
    letter-spacing: 0.2px;
    font-size: 14px;
    text-align: center;
    color: #f39c12;
  }

  .tab-container {
    max-width: 1024px;
    margin: auto;
    padding-top: 16px;
  }

  .grid-checkbox {
    max-width: 600px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .grid-checkbox-item {
      margin: 20px 0;
    }

    > div {
      min-width: 50%;
      margin-left: 0;
    }
  }

  .documentation-container {
    max-width: 600px;
    margin: auto;
  }
`

export const OwnerContainer = styled.div`
  .button-create {
    > div {
      margin-left: auto;
    }
  }
`

export const GenerateReportContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: end;

  .button-action {
    margin-left: auto;
    padding-right: 210px;
    margin-top: 20px;
    button {
      margin: 0;
    }
  }
`
